import React from "react";
import { Routes, Route } from "react-router-dom";
import WidgetList from "./WidgetList";
import WidgetNew from "./WidgetNew";
import WidgetEdit from "./WidgetEdit";

const WidgetAdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<WidgetList />} />
      <Route path="new" element={<WidgetNew />} />
      <Route path=":widgetId/edit" element={<WidgetEdit />} />
    </Routes>
  );
};

export default WidgetAdminRoutes;